import "@/App.css";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import { SmoothScroll } from "@/components/SmoothScroll";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { LeadGate } from "@/components/LeadGate";
import HomePage from "@/pages/HomePage";
import BrandsPage from "@/pages/BrandsPage";
import BrandPage from "@/pages/BrandPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminPage from "@/pages/AdminPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import ConfirmAlertsPage from "@/pages/ConfirmAlertsPage";
import UnsubscribePage from "@/pages/UnsubscribePage";
import ContactPage from "@/pages/ContactPage";
import PromotePage from "@/pages/PromotePage";
import { AboutPage, CategoriesPage, LegalPage, NotFoundPage, RecentPage } from "@/pages/StaticPages";

function PublicRoutes() {
  const location = useLocation();
  return (
    <>
      <Navbar />
      <motion.main key={location.pathname} initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.55, ease: [0.22, 1, 0.36, 1] }}>
        <Routes location={location}>
          <Route path="/" element={<HomePage />} />
          <Route path="/brands" element={<BrandsPage />} />
          <Route path="/brands/:slug" element={<BrandPage />} />
          <Route path="/categories" element={<CategoriesPage />} />
          <Route path="/recent" element={<RecentPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/promote" element={<PromotePage />} />
          <Route path="/legal/contact" element={<ContactPage />} />
          <Route path="/legal/:page" element={<LegalPage />} />
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/admin/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/admin/reset-password" element={<ResetPasswordPage />} />
          <Route path="/unsubscribe" element={<UnsubscribePage />} />
          <Route path="/alerts/confirm" element={<ConfirmAlertsPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </motion.main>
      <Footer />
      <LeadGate />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <SmoothScroll />
        <Routes>
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/*" element={<PublicRoutes />} />
        </Routes>
        <Toaster position="bottom-right" theme="system" richColors closeButton toastOptions={{ style: { borderRadius: 18 } }} />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
